import * as React from 'react';

import { useSubAgentMasterLimitExceed } from './hooks';
import { SubAgentMasterLimitExceed } from './SubAgentMasterLimitExceed';

export const SubAgentMasterLimitExceedContainer = () => {
  const { handleSwitchToSelfPlacingMoneySource } = useSubAgentMasterLimitExceed();

  return <SubAgentMasterLimitExceed handleClick={handleSwitchToSelfPlacingMoneySource} />;
};
